import React, { useContext } from 'react';
import { LocalizationContext } from 'app/localization/Context';

import appicon1 from 'images/appIcon/appicon.png';
import appicon2 from 'images/appIcon/appicon@2x.png';
import appicon3 from 'images/appIcon/appicon@3x.png';

import { ReactComponent as IconShare } from 'images/general/share-ios.svg';
import { ReactComponent as IconAdd } from 'images/general/add-ios-white.svg';

import './AddToHomeScreen.scss'

export default function AddToHomeScreen({ snooze }) {
    const l = useContext(LocalizationContext);
    const a = l.strings.addToHomeScreen;

    return (
        <div className="add-to-home-screen-page"
            dir={l.isRTL ? "rtl" : "ltr"}
            lang={l.language}>
            <div className="bg-blank" />
            <div className="bg-secondary-color" />

            <div className="add-to-home-screen-page-content">
                <div /> {/* 145 */}

                <img src={appicon1}
                    srcSet={`${appicon2} 2x, ${appicon3} 3x`}
                    className="app-icon" alt="" />

                <div /> {/* 34 */}

                <div className="header">{a.header}</div>

                <div /> {/* 26 */}

                <div className="main-content">
                    <IconShare className="icon" />
                    {a.messages[0]}

                    <IconAdd className="icon" />
                    {a.messages[1]}

                    <div className="icon-add-button">Add</div>
                    {a.messages[2]}
                </div>

                <div /> {/* 190 */}

                <div className="snooze-button" onClick={snooze}>{a.snooze}</div>
                
                <div /> {/* 64 */}
            </div>
        </div>
    )
}
